"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformSort = void 0;
var transformSort = function transformSort(name, sortDirection) {
  if (sortDirection === 'IDLE') {
    return undefined;
  }
  var paramDirection = sortDirection === 'ASCENDING' ? 'asc' : 'desc';
  return "".concat(name, ",").concat(paramDirection);
};
exports.transformSort = transformSort;